import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DataToolsService {
	// ==> Objet pour les textes globaux du Json
	private objectGlobalTexts = new BehaviorSubject("")
	currentGlobalTexts = this.objectGlobalTexts.asObservable();

	// ==> String pour get le name du Json des textes / page
	private stringNameJson = new BehaviorSubject("")
	currentNameJson = this.stringNameJson.asObservable();

	// ==> String pour get le les classes du bloc header / page
	private stringClassList = new BehaviorSubject("")
	currentClassList = this.stringClassList.asObservable();

	// ==> Objet pour le current bien (sidebar-recap)
	private objectBien = new BehaviorSubject("")
	currentBien = this.objectBien.asObservable();

	// ==> Objet pour l'estimation (sidebar-recap)
	private objectEstimation = new BehaviorSubject("")
	currentEstimation = this.objectEstimation.asObservable();

	// ==> Objet pour l'estimation (sidebar-recap)
	private totalEstimation = new BehaviorSubject("")
	currentTotalEstimation = this.totalEstimation.asObservable();

	// ==> Array pour pieces (sidebar-menu)
	private arrPieces = new BehaviorSubject("")
	currentPieces = this.arrPieces.asObservable();

	// ==> String pour get le name pour la modal en cours du Json Modal
	private stringModalNameJson = new BehaviorSubject("")
	currentModalNameJson = this.stringModalNameJson.asObservable();

	// ==> get ID autre finition
	private objAutreFinition = new BehaviorSubject("")
	currentObjAutreFinition = this.objAutreFinition.asObservable();

	private modalInfo = new BehaviorSubject("")
	currentModalInfo = this.modalInfo.asObservable();

	// ==> Objet pour l'estimation (sidebar-recap)
	private isTrial = new BehaviorSubject("")
	currentIsTrial = this.isTrial.asObservable();


	setmodalInfo(data: any) {
		this.modalInfo.next(data);
	}

	constructor() {
	}

	// ==> Function pour les textes globaux du Json
	setGlobalTexts(data: any) {
		this.objectGlobalTexts.next(data);
	}

	// ==> Function pour get le name du Json des textes / page
	setNameJson(data: any) {
		this.stringNameJson.next(data);
	}

	// ==> Function pour get les classes du bloc header / page
	setClassList(data: any) {
		this.stringClassList.next(data);
	}

	// ==> Function pour le current bien (sidebar-recap)
	setBien(data: any) {
		this.objectBien.next(data);
	}

	// ==> Function pour l'estimation (sidebar-recap)
	setEstimation(data: any) {
		this.objectEstimation.next(data);
	}

	// ==> Function pour le total de l'estimation (sidebar-recap)
	setTotalEstimation(data: any) {
		this.totalEstimation.next(data);
	}

	setIsTrial(data: any) {
		this.isTrial.next(data);
	}

	// ==> Function pour pieces (sidebar-menu)
	setPieces(data: any) {
		this.arrPieces.next(data);
	}

	// ==> Function pour get le name pour la modal en cours du Json Modal
	setModalNameJson(data: any) {
		this.stringModalNameJson.next(data);
	}

	// ==> Function pour get l'ID autre finition
	setObjAutreFinition(data: any) {
		this.objAutreFinition.next(data);
	}

}
